export const LAST_UPDATE_TIMING_MAPPING = {
  'now-1w': { ja: '1週間以内', en: 'In a week' },
  'now-1m': { ja: '1ヵ月以内', en: 'In a wmonthek' },
  'now-1y': { ja: '1年以内', en: 'In a year' },
}

export interface Era {
  key: string
  name: LangString
  from: string
  to: string
}

export const ERAS: Era[] = [
  {
    key: 'ancient',
    from: '',
    to: '0592-01-01',
    name: {
      ja: '縄文・弥生・古墳',
      en: 'Jomon/Yayoi/Kofun',
    },
  },
  {
    key: 'asuka',
    from: '0592-01-01',
    to: '0710-01-01',
    name: {
      ja: '飛鳥',
      en: 'Asuka',
    },
  },
  {
    key: 'nara',
    from: '0710-01-01',
    to: '0794-01-01',
    name: {
      ja: '奈良',
      en: 'Nara',
    },
  },
  {
    key: 'heian',
    from: '0794-01-01',
    to: '1185-01-01',
    name: {
      ja: '平安',
      en: 'Heian',
    },
  },
  {
    key: 'kamakura',
    from: '1185-01-01',
    to: '1336-01-01',
    name: {
      ja: '鎌倉',
      en: 'Kamakura',
    },
  },
  {
    key: 'muromachi',
    from: '1336-01-01',
    to: '1573-01-01',
    name: {
      ja: '室町',
      en: 'Muromachi',
    },
  },
  {
    key: 'aduchi',
    from: '1573-01-01',
    to: '1602-01-01',
    name: {
      ja: '安土桃山',
      en: 'Aduchi-momoyama',
    },
  },
  {
    key: 'edo',
    from: '1602-01-01',
    to: '1868-10-23',
    name: {
      ja: '江戸',
      en: 'Edo',
    },
  },
  {
    key: 'meiji',
    from: '1868-10-23',
    to: '1912-07-30',
    name: {
      ja: '明治',
      en: 'Meiji',
    },
  },
  {
    key: 'taisyo',
    from: '1912-07-30',
    to: '1926-12-25',
    name: {
      ja: '大正',
      en: 'Taisho',
    },
  },
  {
    key: 'showa',
    from: '1926-12-25',
    to: '1989-01-08',
    name: {
      ja: '昭和',
      en: 'Showa',
    },
  },
  {
    key: 'heisei',
    from: '1989-01-08',
    to: '2019-04-30',
    name: {
      ja: '平成',
      en: 'Heisei',
    },
  },
  {
    key: 'reiwa',
    from: '2019-04-30',
    to: '',
    name: {
      ja: '令和',
      en: 'Reiwa',
    },
  },
]

export interface Prefecture {
  key: string
  name: LangString
  isDefault: boolean
}

export const PREFECTURES: Prefecture[] = [
  {
    key: 'Hokkaido',
    name: {
      ja: '北海道',
      en: 'Hokkaido',
    },
    isDefault: true
  },
  {
    key: 'Aomori',
    name: {
      ja: '青森県',
      en: 'Aomori',
    },
    isDefault: true
  },
  {
    key: 'Iwate',
    name: {
      ja: '岩手県',
      en: 'Iwate',
    },
    isDefault: true
  },
  {
    key: 'Miyagi',
    name: {
      ja: '宮城県',
      en: 'Miyagi',
    },
    isDefault: true
  },
  {
    key: 'Akita',
    name: {
      ja: '秋田県',
      en: 'Akita',
    },
    isDefault: true
  },
  {
    key: 'Yamagata',
    name: {
      ja: '山形県',
      en: 'Yamagata',
    },
    isDefault: true
  },
  {
    key: 'Fukushima',
    name: {
      ja: '福島県',
      en: 'Fukushima',
    },
    isDefault: true
  },
  {
    key: 'Ibaraki',
    name: {
      ja: '茨城県',
      en: 'Ibaraki',
    },
    isDefault: true
  },
  {
    key: 'Tochigi',
    name: {
      ja: '栃木県',
      en: 'Tochigi',
    },
    isDefault: true
  },
  {
    key: 'Gunma',
    name: {
      ja: '群馬県',
      en: 'Gunma',
    },
    isDefault: true
  },
  {
    key: 'Saitama',
    name: {
      ja: '埼玉県',
      en: 'Saitama',
    },
    isDefault: true
  },
  {
    key: 'Chiba',
    name: {
      ja: '千葉県',
      en: 'Chiba',
    },
    isDefault: true
  },
  {
    key: 'Tokyo',
    name: {
      ja: '東京都',
      en: 'Tokyo',
    },
    isDefault: true
  },
  {
    key: 'Kanagawa',
    name: {
      ja: '神奈川県',
      en: 'Kanagawa',
    },
    isDefault: true
  },
  {
    key: 'Niigata',
    name: {
      ja: '新潟県',
      en: 'Niigata',
    },
    isDefault: false
  },
  {
    key: 'Toyama',
    name: {
      ja: '富山県',
      en: 'Toyama',
    },
    isDefault: false
  },
  {
    key: 'Ishikawa',
    name: {
      ja: '石川県',
      en: 'Ishikawa',
    },
    isDefault: false
  },
  {
    key: 'Fukui',
    name: {
      ja: '福井県',
      en: 'Fukui',
    },
    isDefault: false
  },
  {
    key: 'Yamanashi',
    name: {
      ja: '山梨県',
      en: 'Yamanashi',
    },
    isDefault: false
  },
  {
    key: 'Nagano',
    name: {
      ja: '長野県',
      en: 'Nagano',
    },
    isDefault: false
  },
  {
    key: 'Gifu',
    name: {
      ja: '岐阜県',
      en: 'Gifu',
    },
    isDefault: false
  },
  {
    key: 'Shizuoka',
    name: {
      ja: '静岡県',
      en: 'Shizuoka',
    },
    isDefault: false
  },
  {
    key: 'Aichi',
    name: {
      ja: '愛知県',
      en: 'Aichi',
    },
    isDefault: false
  },
  {
    key: 'Mie',
    name: {
      ja: '三重県',
      en: 'Mie',
    },
    isDefault: false
  },
  {
    key: 'Shiga',
    name: {
      ja: '滋賀県',
      en: 'Shiga',
    },
    isDefault: false
  },
  {
    key: 'Kyoto',
    name: {
      ja: '京都府',
      en: 'Kyoto',
    },
    isDefault: false
  },
  {
    key: 'Osaka',
    name: {
      ja: '大阪府',
      en: 'Osaka',
    },
    isDefault: false
  },
  {
    key: 'Hyogo',
    name: {
      ja: '兵庫県',
      en: 'Hyogo',
    },
    isDefault: false
  },
  {
    key: 'Nara',
    name: {
      ja: '奈良県',
      en: 'Nara',
    },
    isDefault: false
  },
  {
    key: 'Wakayama',
    name: {
      ja: '和歌山県',
      en: 'Wakayama',
    },
    isDefault: false
  },
  {
    key: 'Tottori',
    name: {
      ja: '鳥取県',
      en: 'Tottori',
    },
    isDefault: false
  },
  {
    key: 'Shimane',
    name: {
      ja: '島根県',
      en: 'Shimane',
    },
    isDefault: false
  },
  {
    key: 'Okayama',
    name: {
      ja: '岡山県',
      en: 'Okayama',
    },
    isDefault: false
  },
  {
    key: 'Hiroshima',
    name: {
      ja: '広島県',
      en: 'Hiroshima',
    },
    isDefault: false
  },
  {
    key: 'Yamaguchi',
    name: {
      ja: '山口県',
      en: 'Yamaguchi',
    },
    isDefault: false
  },
  {
    key: 'Tokushima',
    name: {
      ja: '徳島県',
      en: 'Tokushima',
    },
    isDefault: false
  },
  {
    key: 'Kagawa',
    name: {
      ja: '香川県',
      en: 'Kagawa',
    },
    isDefault: false
  },
  {
    key: 'Ehime',
    name: {
      ja: '愛媛県',
      en: 'Ehime',
    },
    isDefault: false
  },
  {
    key: 'Kochi',
    name: {
      ja: '高知県',
      en: 'Kochi',
    },
    isDefault: false
  },
  {
    key: 'Fukuoka',
    name: {
      ja: '福岡県',
      en: 'Fukuoka',
    },
    isDefault: false
  },
  {
    key: 'Saga',
    name: {
      ja: '佐賀県',
      en: 'Saga',
    },
    isDefault: false
  },
  {
    key: 'Nagasaki',
    name: {
      ja: '長崎県',
      en: 'Nagasaki',
    },
    isDefault: false
  },
  {
    key: 'Kumamoto',
    name: {
      ja: '熊本県',
      en: 'Kumamoto',
    },
    isDefault: false
  },
  {
    key: 'Oita',
    name: {
      ja: '大分県',
      en: 'Oita',
    },
    isDefault: false
  },
  {
    key: 'Miyazaki',
    name: {
      ja: '宮崎県',
      en: 'Miyazaki',
    },
    isDefault: false
  },
  {
    key: 'Kagoshima',
    name: {
      ja: '鹿児島県',
      en: 'Kagoshima',
    },
    isDefault: false
  },
  {
    key: 'Okinawa',
    name: {
      ja: '沖縄県',
      en: 'Okinawa',
    },
    isDefault: false
  },
]

import SearchFieldKeyword from './search-field/SearchFieldKeyword.vue'
import SearchFieldCode from './search-field/SearchFieldCode.vue'
import SearchFieldLastUpdate from './search-field/SearchFieldLastUpdate.vue'
import SearchFieldExist from './search-field/SearchFieldExist.vue'
import SearchFieldCoordinates from './search-field/SearchFieldCoordinates.vue'
import SearchFieldTimeRange from './search-field/SearchFieldTimeRange.vue'
import SearchFieldContents from './search-field/SearchFieldContents.vue'
import SearchFieldOwnerOrg from './search-field/SearchFieldOwnerOrg.vue'
import SearchFieldPermission from './search-field/SearchFieldPermission.vue'
import SearchFieldTag from './search-field/SearchFieldTag.vue'
import SearchFieldRdfType from './search-field/SearchFieldRdfType.vue'
import SearchFieldProvider from './search-field/SearchFieldProvider.vue'
import SearchFieldLocation from './search-field/SearchFieldLocation.vue'
import SearchFieldPrefectures from './search-field/SearchFieldPrefectures.vue'
import SearchFieldTemporal from './search-field/SearchFieldTemporal.vue'
import SearchFieldTemporalGroup from './search-field/SearchFieldTemporalGroup.vue'
import SearchFieldNumberRange from './search-field/SearchFieldNumberRange.vue'
import './search-field/search-field-style.postcss'

const SearchFieldImage = defineAsyncComponent(
  () => import('./search-field/SearchFieldImage.vue'),
)
const SearchFieldDatabase = defineAsyncComponent(
  () => import('./search-field/SearchFieldDatabase.vue'),
)
const SearchFieldOrganization = defineAsyncComponent(
  () => import('./search-field/SearchFieldOrganization.vue'),
)

export const useSearchField = () => {

  const searchFieldComponent = (field: CustomSearchField) => {
    if (!field.type) field.type = 'keyword'
    switch (field.type) {
      case 'keyword':
        return SearchFieldKeyword
      case 'code':
        return SearchFieldCode
      case 'last_update':
        return SearchFieldLastUpdate
      case 'exist':
        return SearchFieldExist
      case 'coordinates':
        return SearchFieldCoordinates
      case 'time_range':
        return SearchFieldTimeRange
      case 'contents':
        return SearchFieldContents
      case 'owner_org':
        return SearchFieldOwnerOrg
      case 'permission':
        return SearchFieldPermission
      case 'tag':
        return SearchFieldTag
      case 'rdf_type':
        return SearchFieldRdfType
      case 'provider':
        return SearchFieldProvider
      case 'location':
        return SearchFieldLocation
      case 'prefectures':
        return SearchFieldPrefectures
      case 'temporal':
        return SearchFieldTemporal
      case 'temporal_group':
        return SearchFieldTemporalGroup
      case 'number_range':
        return SearchFieldNumberRange
      case 'image':
        return SearchFieldImage
      case 'database':
        return SearchFieldDatabase
      case 'organization':
        return SearchFieldOrganization
    }
  }

  const getEra = (key: string): Era => {
    return ERAS.filter(era => era.key === key).pop()
  }

  const getPrefecture = (key: string): Prefecture => {
    return PREFECTURES.filter(prefecture => prefecture.key === key).pop()
  }

  return {
    searchFieldComponent,
    getEra,
    getPrefecture,
  }

}
